var _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _circle, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _path4, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _g2, _path5, _path6, _path7, _g3, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _path8, _path9, _circle2, _rect59, _rect60, _rect61, _rect62, _rect63, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 868,
    height: 828,
    viewBox: "0 0 868 828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1233_5007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 64,
    width: 452,
    height: 452,
    rx: 16,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 80,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FF5454"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 80,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FFCF54"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 80,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#1FCC83"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 104,
    width: 432,
    height: 404,
    rx: 16,
    fill: "#F6F6F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 196,
    width: 216,
    height: 124,
    rx: 12,
    fill: "#7D2BD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.286 277.8V285.184H374.174V277.8H370.742V296H374.174V288.174H382.286V296H385.718V277.8H382.286ZM397.911 291.632C397.573 292.88 396.507 293.556 394.869 293.556C392.841 293.556 391.489 292.204 391.255 290.098H400.927C400.953 289.838 400.979 289.448 400.979 289.006C400.979 285.886 399.003 282.688 394.609 282.688C390.319 282.688 388.187 285.938 388.187 289.396C388.187 292.828 390.579 296.208 394.869 296.208C398.093 296.208 400.537 294.414 401.031 291.632H397.911ZM394.609 285.08C396.507 285.08 397.651 286.328 397.781 287.992H391.333C391.671 286.016 392.815 285.08 394.609 285.08ZM403.366 296H406.538V277.28H403.366V296ZM409.764 296H412.936V277.28H409.764V296ZM422.143 296.208C426.121 296.208 428.981 293.348 428.981 289.448C428.981 285.548 426.121 282.688 422.143 282.688C418.139 282.688 415.279 285.548 415.279 289.448C415.279 293.348 418.139 296.208 422.143 296.208ZM422.143 293.452C419.959 293.452 418.503 291.814 418.503 289.448C418.503 287.082 419.959 285.444 422.143 285.444C424.301 285.444 425.757 287.082 425.757 289.448C425.757 291.814 424.301 293.452 422.143 293.452Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 156,
    r: 12,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 152,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 332,
    width: 105,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 348,
    width: 44,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 364,
    width: 76,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 152,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 408,
    width: 64,
    height: 20,
    rx: 10,
    fill: "#383838"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 416,
    width: 20,
    height: 4,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244 120C244 111.163 251.163 104 260 104H336V508H260C251.163 508 244 500.837 244 492V120Z",
    fill: "#3F4042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M584 104H660C668.837 104 676 111.163 676 120V492C676 500.837 668.837 508 660 508H584V104Z",
    fill: "#3F4042"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 104,
    width: 428,
    height: 24,
    rx: 12,
    fill: "#3F4042"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 128,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#2A2B2D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 481,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 128,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#2A2B2D"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 152,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#3979C7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 152,
    width: 46,
    height: 12,
    rx: 6,
    fill: "#57595C"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 170,
    width: 68,
    height: 51,
    rx: 12,
    fill: "#57595C"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 604,
    y: 193,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7A7D82"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 626,
    y: 178,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7A7D82"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 626,
    y: 208,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7A7D82"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 193,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#7A7D82"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 232,
    width: 68,
    height: 51,
    rx: 12,
    fill: "#57595C"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 310,
    width: 68,
    height: 51,
    rx: 12,
    fill: "#57595C"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 442,
    width: 68,
    height: 51,
    rx: 12,
    fill: "#57595C"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 374,
    width: 32,
    height: 14,
    rx: 7,
    fill: "#57595C"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 292,
    width: 52,
    height: 8,
    rx: 4,
    fill: "#2A2B2D"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 134,
    width: 70,
    height: 12,
    rx: 6,
    fill: "#2A2B2D"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 134,
    width: 34,
    height: 12,
    rx: 4,
    fill: "#3979C7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 176,
    width: 46,
    height: 12,
    rx: 4,
    fill: "#57595C"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 200,
    width: 38,
    height: 12,
    rx: 4,
    fill: "#57595C"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 224,
    width: 22,
    height: 12,
    rx: 4,
    fill: "#57595C"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 248,
    width: 14,
    height: 12,
    rx: 4,
    fill: "#57595C"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 272,
    width: 30,
    height: 12,
    rx: 4,
    fill: "#57595C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M610 108C610 105.791 611.791 104 614 104H660C668.837 104 676 111.163 676 120C676 122.209 674.209 124 672 124H614C611.791 124 610 122.209 610 120V108Z",
    fill: "#2A2B2D"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#64676B"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#64676B"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 644,
    y: 110,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#64676B"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 152,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 176,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 460,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 200,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 484,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#9E9FA1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1233_5007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 664,
    cy: 84,
    r: 12,
    fill: "#00D37F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M660.658 78.0887C660.658 80.0745 662.268 81.6844 664.254 81.6844H668.539C668.589 81.6844 668.629 81.6441 668.629 81.5945C668.629 79.6086 667.019 77.9988 665.034 77.9988H660.748C660.698 77.9988 660.658 78.039 660.658 78.0887Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M660.572 85.7226C660.572 83.6994 662.212 82.0594 664.235 82.0594H668.559C668.61 82.0594 668.651 82.1004 668.651 82.1509C668.651 84.1741 667.011 85.8142 664.988 85.8142H660.664C660.613 85.8142 660.572 85.7732 660.572 85.7226Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M664.432 86.3207C664.432 88.3527 662.784 90 660.752 90L660.669 90C660.617 90 660.575 89.9579 660.575 89.9059L660.575 87.849C660.575 86.9542 661.3 86.2287 662.195 86.2287L664.34 86.2287C664.39 86.2287 664.432 86.2699 664.432 86.3207Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1233_5007)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 452,
    height: 452,
    rx: 16,
    fill: "white"
  }))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 168,
    width: 208,
    height: 24,
    rx: 12,
    fill: "#F6F6F6"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 200,
    width: 432,
    height: 404,
    rx: 16,
    fill: "#F6F6F6"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 560,
    width: 96,
    height: 20,
    rx: 10,
    fill: "#383838"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 568,
    width: 42,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 456,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 456,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 456,
    width: 19,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 472,
    width: 96,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 488,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 268,
    width: 384,
    height: 164,
    rx: 12,
    fill: "#00D37F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.082 410H157.2V397.764H164.008C170.724 397.764 174.726 393.624 174.726 387.782C174.726 381.94 170.724 377.8 164.008 377.8H151.082V410ZM157.2 392.658V382.906H163.732C167.32 382.906 168.792 385.206 168.792 387.782C168.792 390.358 167.32 392.658 163.732 392.658H157.2ZM192.418 391.554V386.816H189.704C186.714 386.816 184.92 387.966 183.77 390.91V386.816H178.112V410H183.77V399.052C183.77 394.636 185.196 391.554 188.784 391.554H192.418ZM205.725 410.368C212.763 410.368 217.823 405.308 217.823 398.408C217.823 391.508 212.763 386.448 205.725 386.448C198.641 386.448 193.581 391.508 193.581 398.408C193.581 405.308 198.641 410.368 205.725 410.368ZM205.725 405.492C201.861 405.492 199.285 402.594 199.285 398.408C199.285 394.222 201.861 391.324 205.725 391.324C209.543 391.324 212.119 394.222 212.119 398.408C212.119 402.594 209.543 405.492 205.725 405.492ZM231.439 410.368C234.245 410.368 236.821 409.126 238.155 407.102V410H243.767V376.88H238.155V389.622C236.821 387.736 234.383 386.448 231.347 386.448C224.493 386.448 220.399 391.324 220.399 398.408C220.399 405.492 224.493 410.368 231.439 410.368ZM232.267 405.492C228.495 405.492 226.011 402.686 226.011 398.408C226.011 394.13 228.495 391.324 232.267 391.324C236.039 391.324 238.523 394.13 238.523 398.408C238.523 402.686 236.039 405.492 232.267 405.492ZM270.033 386.816H264.375V399.466C264.375 402.87 262.167 405.354 258.993 405.354C256.141 405.354 254.163 403.146 254.163 399.972V386.816H248.551V401.168C248.551 406.596 251.955 410.368 257.153 410.368C260.465 410.368 263.087 408.942 264.375 406.412V410H270.033V386.816ZM285.632 410.368C291.612 410.368 296.12 406.734 296.856 401.674H291.152C290.6 403.974 288.53 405.492 285.862 405.492C281.906 405.492 279.744 402.456 279.744 398.408C279.744 394.36 281.86 391.324 285.77 391.324C288.438 391.324 290.692 392.98 291.106 395.28H296.718C296.212 389.944 291.474 386.448 285.632 386.448C278.41 386.448 273.856 391.784 273.856 398.408C273.856 405.032 278.41 410.368 285.632 410.368ZM302.927 379.824V386.816H298.373V391.554H302.927V401.904C302.927 407.056 306.239 410 311.299 410H315.025V405.216H311.943C309.827 405.216 308.585 404.02 308.585 401.674V391.554H315.025V386.816H308.585V379.824H302.927ZM329.08 410.368C336.118 410.368 341.178 405.308 341.178 398.408C341.178 391.508 336.118 386.448 329.08 386.448C321.996 386.448 316.936 391.508 316.936 398.408C316.936 405.308 321.996 410.368 329.08 410.368ZM329.08 405.492C325.216 405.492 322.64 402.594 322.64 398.408C322.64 394.222 325.216 391.324 329.08 391.324C332.898 391.324 335.474 394.222 335.474 398.408C335.474 402.594 332.898 405.492 329.08 405.492Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M251.436 185H252.948L254.376 180.254L255.79 185H257.316L259.556 177.944H257.848L256.546 182.662L255.16 177.944H253.578L252.192 182.662L250.904 177.944H249.182L251.436 185ZM262.168 185H263.68L265.108 180.254L266.522 185H268.048L270.288 177.944H268.58L267.278 182.662L265.892 177.944H264.31L262.924 182.662L261.636 177.944H259.914L262.168 185ZM272.901 185H274.413L275.841 180.254L277.255 185H278.781L281.021 177.944H279.313L278.011 182.662L276.625 177.944H275.043L273.657 182.662L272.369 177.944H270.647L272.901 185ZM280.974 183.18V185H282.836V183.18H280.974ZM287.14 185.112C288.792 185.112 289.87 184.244 289.87 182.914C289.87 179.722 285.95 181.402 285.95 179.876C285.95 179.4 286.356 179.12 286.972 179.12C287.518 179.12 288.12 179.456 288.218 180.114H289.786C289.716 178.742 288.582 177.832 286.93 177.832C285.474 177.832 284.396 178.7 284.396 179.932C284.396 182.914 288.26 181.416 288.26 182.984C288.26 183.404 287.812 183.74 287.14 183.74C286.37 183.74 285.852 183.32 285.782 182.648H284.214C284.298 184.16 285.432 185.112 287.14 185.112ZM291.003 174.92V176.838H292.851V174.92H291.003ZM291.073 185H292.795V177.944H291.073V185ZM295.208 175.816V177.944H293.822V179.386H295.208V182.536C295.208 184.104 296.216 185 297.756 185H298.89V183.544H297.952C297.308 183.544 296.93 183.18 296.93 182.466V179.386H298.89V177.944H296.93V175.816H295.208ZM304.708 182.648C304.526 183.32 303.952 183.684 303.07 183.684C301.978 183.684 301.25 182.956 301.124 181.822H306.332C306.346 181.682 306.36 181.472 306.36 181.234C306.36 179.554 305.296 177.832 302.93 177.832C300.62 177.832 299.472 179.582 299.472 181.444C299.472 183.292 300.76 185.112 303.07 185.112C304.806 185.112 306.122 184.146 306.388 182.648H304.708ZM302.93 179.12C303.952 179.12 304.568 179.792 304.638 180.688H301.166C301.348 179.624 301.964 179.12 302.93 179.12ZM307.334 183.18V185H309.196V183.18H307.334ZM313.734 185.112C315.554 185.112 316.926 184.006 317.15 182.466H315.414C315.246 183.166 314.616 183.628 313.804 183.628C312.6 183.628 311.942 182.704 311.942 181.472C311.942 180.24 312.586 179.316 313.776 179.316C314.588 179.316 315.274 179.82 315.4 180.52H317.108C316.954 178.896 315.512 177.832 313.734 177.832C311.536 177.832 310.15 179.456 310.15 181.472C310.15 183.488 311.536 185.112 313.734 185.112ZM321.57 185.112C323.712 185.112 325.252 183.572 325.252 181.472C325.252 179.372 323.712 177.832 321.57 177.832C319.414 177.832 317.874 179.372 317.874 181.472C317.874 183.572 319.414 185.112 321.57 185.112ZM321.57 183.628C320.394 183.628 319.61 182.746 319.61 181.472C319.61 180.198 320.394 179.316 321.57 179.316C322.732 179.316 323.516 180.198 323.516 181.472C323.516 182.746 322.732 183.628 321.57 183.628ZM326.415 185H328.137V180.954C328.137 179.96 328.711 179.302 329.621 179.302C330.447 179.302 330.965 179.96 330.965 180.954V185H332.673V180.954C332.673 179.96 333.247 179.302 334.171 179.302C334.997 179.302 335.515 179.96 335.515 180.954V185H337.223V180.436C337.223 178.938 336.243 177.832 334.717 177.832C333.597 177.832 332.701 178.448 332.379 179.176C332.071 178.308 331.301 177.832 330.181 177.832C329.187 177.832 328.487 178.336 328.137 179.05V177.944H326.415V185ZM338.158 185.014H339.698L344.108 175.2H342.554L338.158 185.014ZM344.313 187.856H346.021V184.23C346.413 184.776 347.169 185.112 348.023 185.112C350.095 185.112 351.425 183.628 351.425 181.472C351.425 179.316 350.179 177.832 348.149 177.832C347.211 177.832 346.441 178.224 346.021 178.826V177.944H344.313V187.856ZM347.827 183.628C346.665 183.628 345.909 182.774 345.909 181.472C345.909 180.17 346.665 179.316 347.827 179.316C348.961 179.316 349.717 180.17 349.717 181.472C349.717 182.774 348.961 183.628 347.827 183.628ZM356.937 179.386V177.944H356.111C355.201 177.944 354.655 178.294 354.305 179.19V177.944H352.583V185H354.305V181.668C354.305 180.324 354.739 179.386 355.831 179.386H356.937ZM360.986 185.112C363.128 185.112 364.668 183.572 364.668 181.472C364.668 179.372 363.128 177.832 360.986 177.832C358.83 177.832 357.29 179.372 357.29 181.472C357.29 183.572 358.83 185.112 360.986 185.112ZM360.986 183.628C359.81 183.628 359.026 182.746 359.026 181.472C359.026 180.198 359.81 179.316 360.986 179.316C362.148 179.316 362.932 180.198 362.932 181.472C362.932 182.746 362.148 183.628 360.986 183.628ZM368.813 185.112C369.667 185.112 370.451 184.734 370.857 184.118V185H372.565V174.92H370.857V178.798C370.451 178.224 369.709 177.832 368.785 177.832C366.699 177.832 365.453 179.316 365.453 181.472C365.453 183.628 366.699 185.112 368.813 185.112ZM369.065 183.628C367.917 183.628 367.161 182.774 367.161 181.472C367.161 180.17 367.917 179.316 369.065 179.316C370.213 179.316 370.969 180.17 370.969 181.472C370.969 182.774 370.213 183.628 369.065 183.628ZM380.558 177.944H378.836V181.794C378.836 182.83 378.164 183.586 377.198 183.586C376.33 183.586 375.728 182.914 375.728 181.948V177.944H374.02V182.312C374.02 183.964 375.056 185.112 376.638 185.112C377.646 185.112 378.444 184.678 378.836 183.908V185H380.558V177.944ZM385.306 185.112C387.126 185.112 388.498 184.006 388.722 182.466H386.986C386.818 183.166 386.188 183.628 385.376 183.628C384.172 183.628 383.514 182.704 383.514 181.472C383.514 180.24 384.158 179.316 385.348 179.316C386.16 179.316 386.846 179.82 386.972 180.52H388.68C388.526 178.896 387.084 177.832 385.306 177.832C383.108 177.832 381.722 179.456 381.722 181.472C381.722 183.488 383.108 185.112 385.306 185.112ZM390.57 175.816V177.944H389.184V179.386H390.57V182.536C390.57 184.104 391.578 185 393.118 185H394.252V183.544H393.314C392.67 183.544 392.292 183.18 392.292 182.466V179.386H394.252V177.944H392.292V175.816H390.57ZM398.529 185.112C400.671 185.112 402.211 183.572 402.211 181.472C402.211 179.372 400.671 177.832 398.529 177.832C396.373 177.832 394.833 179.372 394.833 181.472C394.833 183.572 396.373 185.112 398.529 185.112ZM398.529 183.628C397.353 183.628 396.569 182.746 396.569 181.472C396.569 180.198 397.353 179.316 398.529 179.316C399.691 179.316 400.475 180.198 400.475 181.472C400.475 182.746 399.691 183.628 398.529 183.628Z",
    fill: "#2B2C2E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 228,
    r: 12,
    fill: "#C4C4C4"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 224,
    width: 26,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 388,
    y: 224,
    width: 54,
    height: 8,
    rx: 4,
    fill: "#C4C4C4"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 176,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FF5454"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 176,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#FFCF54"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 176,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#1FCC83"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1233_5007",
    x: 136,
    y: 0,
    width: 732,
    height: 732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 40,
    dy: 76
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1233_5007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1233_5007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1233_5007",
    x: 552,
    y: 8,
    width: 304,
    height: 304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 40,
    dy: 76
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1233_5007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1233_5007",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1233_5007",
    x: 0,
    y: 96,
    width: 732,
    height: 732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 40,
    dy: 76
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1233_5007"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1233_5007",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIllustration);
export default __webpack_public_path__ + "static/media/appIllustration.07fd95b1f6cd80c4f374c89685aa9bfe.svg";
export { ForwardRef as ReactComponent };